module.exports = __webpack_public_path__ + "media/images/bg/hero/brodno-pricing-70bb5340978ceb0709d6e97f567b8608.webp";